import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Alert from 'react-bootstrap/Alert';
import Spinner from '../../../../layout/Spinner/snipper.component';
import { groupBy, get, includes, toNumber, size } from 'lodash';
// import { dummyDataLengthByType, noDummyDataLengthByType } from './dummy_data'

import { domainMaterial } from './domain-material';
import { subtypes } from '../subtype';
import './table-length-by-type.style.css';


export class TableLengthByType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            colums: [],
            products: []
        }
    }

    transformObject = (objectSource) => {
        try {

            //create data to template
            let outPutArray = [];
            for (let key in objectSource) {
                let newObject = {};
                newObject['id'] = key;
                newObject['category'] = subtypes[key];
                let arrayTam = objectSource[key];
                let total = 0;
                for (let i = 0; i < arrayTam.length; i++) {
                    const nameKey = arrayTam[i]['MATERIAL'];
                    newObject[`${nameKey}`] = { 'name': domainMaterial[nameKey], 'value': toNumber(arrayTam[i]['LenghtOfMaterial']).toFixed(2) }
                    total += toNumber(arrayTam[i]['LenghtOfMaterial']);
                }
                newObject['total'] = total.toFixed(2);
                outPutArray.push(newObject);
            }


            //initial arrayKey
            let initialArrayKey = Object.keys(outPutArray[0]);
            outPutArray.map((element) => {
                for (const key in element) {
                    if (!initialArrayKey.includes(key)) {
                        initialArrayKey.push(key);
                    }
                }
                return ''
            });

            //loop outPutArray, to add default zero length to material
            let finalArray = outPutArray.map((element) => {
                initialArrayKey.map((element2) => {
                    let arrayKeyOfOutputArray = Object.keys(element);
                    if (!arrayKeyOfOutputArray.includes(element2)) {
                        element[`${element2}`] = { 'name': domainMaterial[element2], 'value': 0 }
                    }
                    return ''
                });
                return { ...element }
            });
            return finalArray;
        } catch (error) {
            console.log('Error transformObject: ', error);
            return {}
        }
    }
    //render() => here
    formatDataLengthByType = (dataLengthByType) => {
        try {
            //customize dataLengthByType from [{attributes: {xxx}},{attributes: {yyy}},...] => [{xxx},{yyy},...]
            let cusDataLengthByType = dataLengthByType.map((element) => {
                return { ...element['attributes'] }
            });
            //group data by type
            let groupDataLengthByType = groupBy(cusDataLengthByType, 'TYPE');
            if (!size(groupDataLengthByType)) {
                return
            }
            let finalData = this.transformObject(groupDataLengthByType);
            // console.log('finalData: ',finalData);
            return finalData;

        } catch (error) {
            console.log('Error formatDataLengthByType: ',);
        }
    }

    createCol = (dataLengthByType) => {
        try {
            if (Array.isArray(dataLengthByType) && dataLengthByType.length) {
                let oneObject = dataLengthByType[0];
                let arrayAllKey = Object.keys(oneObject);
                let arrayKeyDontUse = ['id', 'category', 'total'];
                let arrayUseKey = arrayAllKey.filter((element) => {
                    return !arrayKeyDontUse.includes(element)
                })
                let arrayColInfo = arrayUseKey.map((element) => {
                    return {
                        dataField: `${element}`, text: `${oneObject[element]['name']}`,
                        footer: columnData => columnData.reduce((acc, item) => (toNumber(acc) + toNumber(item)).toFixed(2), 0),
                        footerStyle: {
                            backgroundColor: '#D9FFF8'
                        }
                    }
                })

                arrayColInfo.unshift({
                    dataField: 'category', text: 'Category', footer: 'Total (km)',
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                arrayColInfo.unshift({
                    dataField: 'id', text: '#', footer: '-',
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                arrayColInfo.push({
                    dataField: 'total',
                    text: 'Total (km)',
                    footer: columnData => columnData.reduce((acc, item) => (toNumber(acc) + toNumber(item)).toFixed(2), 0),
                    style: { backgroundColor: '#D9FFF8' },
                    headerStyle: {
                        backgroundColor: '#D9FFF8'
                    },
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                // console.log('result: ', JSON.stringify(arrayColInfo))
                return arrayColInfo;
            } else {
                return []
            }
        } catch (error) {
            console.log('Error createCol: ', error);
            return []
        }
    }

    createProduct = (dataLengthByType) => {
        try {
            if (Array.isArray(dataLengthByType) && dataLengthByType.length) {
                let arrayProduct = dataLengthByType.map((element) => {
                    return this.transformObject2(element);
                });
                // console.log('array product: ', arrayProduct);
                return arrayProduct;
            } else {
                return []
            }
        } catch (error) {
            console.log('Error createProduct: ', error);
            return []
        }
    }

    transformObject2 = (objectSource) => {
        try {
            const tamp = ['id', 'category', 'total'];
            let newObject = {}
            for (let key in objectSource) {
                if (tamp.includes(key)) {
                    newObject[key] = objectSource[key];
                } else {
                    newObject[key] = objectSource[key].value;
                }
            }
            return newObject;
        } catch (error) {
            console.log('Error transformObject2: ', error);
            return {}
        }
    }

    render() {
        if (this.props.loading) {
            return <Spinner />
        }

        let formatedDataLengthByType = this.formatDataLengthByType(this.props.dataLengthByType);

        const columns = this.createCol(formatedDataLengthByType);
        const products = this.createProduct(formatedDataLengthByType);

        if (Array.isArray(columns) && columns.length) {
            return (
                <div>
                    <BootstrapTable keyField='id' data={products} columns={columns} wrapperClasses="table-responsive" version='4' />
                </div>
            )
        }
        else {
            return (
                <div>
                    {this.props.hasData ? (
                        <Alert variant='info'>
                            Please click search to show your data!
                        </Alert>
                    ) : (
                            <Alert variant='danger'>
                                No data found!
                            </Alert>)}
                </div>
            )
        }
    }
}

export default TableLengthByType
